// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStatusQuestionMarkCircleSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12zm10-6a4 4 0 0 0-3.97 3.501c-.033.274.194.499.47.499h1c.276 0 .494-.227.562-.495A2.008 2.008 0 0 1 12 8c1.1 0 2 .9 2 2 0 .88-.58 1.324-1.23 1.822-.747.573-1.588 1.217-1.744 2.677-.03.275.198.501.474.501h1c.276 0 .493-.228.553-.497.178-.8.776-1.323 1.388-1.857C15.21 11.973 16 11.283 16 10c0-2.21-1.79-4-4-4zm-1 11.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgStatusQuestionMarkCircleSolid;
